import * as z from 'zod';

export const AccountSettingsSchema = z.object({
  name: z.string().min(1, {
    message: 'Name is required',
  }),
  email: z
    .string()
    .email({
      message: 'Invalid email format',
    })
    .optional(),
  phone: z.string().min(1, {
    message: 'Phone number is required',
  }),

  companyAddress: z.string().min(1, {
    message: 'Company address is required',
  }),
  zipCode: z.string().min(1, {
    message: 'Zip code is required',
  }),
  city: z.string().min(1, {
    message: 'City is required',
  }),
  country: z.string().min(1, {
    message: 'Country is required',
  }),

  field: z.string().min(1, {
    message: 'Field of operation is required',
  }),
  companyName: z.string().min(1, {
    message: 'Company name is required',
  }),
  taxId: z.string().min(1, {
    message: 'Tax ID is required',
  }),
  registrationNumber: z.string().optional(),
  invoiceNumberPrefix: z
    .string()
    .max(20, { message: 'Maximum 20 characters' })
    .optional(),

  bankName: z.string().min(1, {
    message: 'Bank name is required',
  }),
  accountNumber: z.string().min(1, {
    message: 'Account number is required',
  }),
  bic: z.string().optional(),

  signInvoice: z.optional(z.boolean()),
  currency: z.string().min(1, {
    message: 'Currency is required',
  }),
  logo: z.string().optional(),
  enableExpenses: z.boolean().optional(),
});

export const PasswordSettingsSchema = z
  .object({
    password: z.optional(z.string()),
    newPassword: z.optional(z.string()),
  })
  .refine(
    (data) => {
      if (data.newPassword && !data.password) {
        return false;
      }

      return true;
    },
    {
      message: 'Password is required',
      path: ['password'],
    }
  )
  .refine(
    (data) => {
      if (data.password && !data.newPassword) {
        return false;
      }

      return true;
    },
    {
      message: 'New password is required',
      path: ['newPassword'],
    }
  );

export const SetPasswordSchema = z.object({
  newPassword: z.string().min(6, {
    message: 'Minimum 6 characters required',
  }),
});

export const TwoFASchema = z.object({
  isTwoFactorEnabled: z.optional(z.boolean()),
});
